module.exports = __webpack_public_path__ + "static/media/download-icon.c059c95b.svg";